export const loadImg = (url) => {
  return new Promise((resolve, reject) => {
    try {
      let img = new Image();
      img.crossOrigin = "Anonymous"; //解决跨域问题
      img.onload = function () {
        resolve(img);
      };
      img.src = url
    } catch (e) {
      reject(e);
      console.log(e);
    }
  });
}

export const calculateTransform = async (srcPoints, dstPoints) => {

  const flattenPoints = (points) => {
    const result = [];
    for (const point of points) {
      result.push(point[0], point[1]);
    }
    return result;
  }
  // 计算单应性矩阵
  const calculateHomography = () => {
    return new Promise((resolve, reject) => {
      try {
        const cv = window.cv;

        // 创建源点和目标点矩阵
        const srcMat = cv.matFromArray(4, 1, cv.CV_32FC2, flattenPoints(srcPoints));
        const dstMat = cv.matFromArray(4, 1, cv.CV_32FC2, flattenPoints(dstPoints));

        // 计算单应性矩阵
        const homography = cv.findHomography(srcMat, dstMat);
        console.log(homography.data64F, 'homography ')
        // 转换为JavaScript数组
        const matrix = [];
        for (let i = 0; i < 3; i++) {
          const row = [];
          for (let j = 0; j < 3; j++) {
            row.push(homography.doubleAt(i, j));
          }
          matrix.push(row);
        }

        // 计算重投影误差
        const error = calculateReprojectionError(srcMat, dstMat, homography);

        // 清理内存
        srcMat.delete();
        dstMat.delete();
        homography.delete();
        resolve(matrix);

      } catch (error) {
        reject(error);
      }
    });
  }

  // 计算重投影误差
  const calculateReprojectionError = (srcMat, dstMat, homography) => {
    const cv = window.cv;

    const transformedPoints = new cv.Mat();
    cv.perspectiveTransform(srcMat, transformedPoints, homography);

    let totalError = 0;
    for (let i = 0; i < 4; i++) {
      const tx = transformedPoints.floatAt(i * 2);
      const ty = transformedPoints.floatAt(i * 2 + 1);
      const dx = dstPoints[i][0] - tx;
      const dy = dstPoints[i][1] - ty;
      totalError += Math.sqrt(dx * dx + dy * dy);
    }

    transformedPoints.delete();
    return totalError / 4;
  }
  try {
    const result = await calculateHomography();
    return result
  } catch (error) {
    console.error('计算失败:', error);
    alert('变换矩阵计算失败: ' + error.message);
  } finally {
  }
}


export const calculatePerspectiveTransform = (srcPoints, dstPoints) => {
  // srcPoints: 原图四个点坐标 [[x1,y1], [x2,y2], [x3,y3], [x4,y4]]
  // dstPoints: 目标四个点坐标 [[X1,Y1], [X2,Y2], [X3,Y3], [X4,Y4]]

  try {
    // 输入验证
    if (srcPoints.length !== 4 || dstPoints.length !== 4) {
      throw new Error('需要4个源点和4个目标点');
    }

    // 构建系数矩阵
    const A = [];
    const b = [];

    for (let i = 0; i < 4; i++) {
      const [x, y] = srcPoints[i];
      const [u, v] = dstPoints[i];

      // 方程1: 用于计算u坐标
      A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]);
      b.push(u);

      // 方程2: 用于计算v坐标
      A.push([0, 0, 0, x, y, 1, -v * x, -v * y]);
      b.push(v);
    }

    // 使用SVD分解求解最小二乘问题
    const h = solveWithSVD(A, b);

    // 构建3x3单应性矩阵
    return [
      [Number(h[0].toFixed(9)), Number(h[1].toFixed(9)), Number(h[2].toFixed(9))],
      [Number(h[3].toFixed(9)), Number(h[4].toFixed(9)), Number(h[5].toFixed(9))],
      [Number(h[6].toFixed(9)), Number(h[7].toFixed(9)), 1]
    ];
  } catch (error) {
    console.error('计算透视变换时出错:', error);
  }
}

function solveWithSVD(A, b) {
  const m = A.length;
  const n = A[0].length;

  // 计算 A^T * A 和 A^T * b
  const ATA = Array(n).fill(0).map(() => Array(n).fill(0));
  const ATb = Array(n).fill(0);

  for (let i = 0; i < n; i++) {
    for (let j = 0; j < n; j++) {
      for (let k = 0; k < m; k++) {
        ATA[i][j] += A[k][i] * A[k][j];
      }
    }
    for (let k = 0; k < m; k++) {
      ATb[i] += A[k][i] * b[k];
    }
  }

  // 解方程 ATA * x = ATb
  return solveLinearSystem(ATA, ATb);
}


export const getRectangleCenter = (points) => {
  // 检查输入是否为4个点
  if (!Array.isArray(points) || points.length !== 4) {
    throw new Error('需要提供4个点的坐标数组');
  }

  let sumX = 0;
  let sumY = 0;

  // 累加所有点的x坐标和y坐标
  for (let i = 0; i < points.length; i++) {
    const point = points[i];
    if (!point || typeof point.x !== 'number' || typeof point.y !== 'number') {
      throw new Error('每个点必须包含x和y坐标属性');
    }
    sumX += point.x;
    sumY += point.y;
  }

  // 计算平均值得到中心点
  const centerX = sumX / points.length;
  const centerY = sumY / points.length;

  return { x: centerX, y: centerY };
}

export const analyzeTransformation = (matrix) => {
  // 提取线性变换部分
  const a = matrix[0][0];
  const b = matrix[0][1];
  const c = matrix[1][0];
  const d = matrix[1][1];

  // 设置阈值，忽略数值误差
  const threshold = 1e-10;

  // 计算行列式（判断是否有翻转）
  const determinant = a * d - b * c;

  // 计算缩放因子
  const scaleX = Math.sqrt(a * a + c * c);
  const scaleY = Math.sqrt(b * b + d * d);

  // 判断是否有剪切
  const hasShear = Math.abs(b) > threshold || Math.abs(c) > threshold;

  // 初始化结果
  let rotationAngle = 0;
  let hasHorizontalFlip = false;
  let hasVerticalFlip = false;

  // 情况1：矩阵接近对角矩阵（无旋转）
  if (Math.abs(b) < threshold && Math.abs(c) < threshold) {
    // 检查是否是180度旋转的特殊情况
    if (Math.abs(a + 1) < threshold && Math.abs(d + 1) < threshold) {
      rotationAngle = 180;
    } else {
      rotationAngle = 0;
    }

    // 判断翻转
    hasHorizontalFlip = a < 0;
    hasVerticalFlip = d < 0;
  }
  // 情况2：矩阵有剪切（有旋转）
  else {
    // 计算旋转角度
    rotationAngle = Math.atan2(c, a) * (180 / Math.PI);

    // 规范化角度到 [-180, 180] 范围
    if (rotationAngle > 180) rotationAngle -= 360;
    if (rotationAngle <= -180) rotationAngle += 360;

    // 判断翻转
    hasHorizontalFlip = determinant < 0 && scaleX * scaleY > threshold;

    // 对于有旋转的情况，垂直翻转的判断更复杂
    // 我们可以检查变换后的y轴方向
    const transformedYAxisX = b;
    const transformedYAxisY = d;
    const yAxisAngle = Math.atan2(transformedYAxisY, transformedYAxisX) * (180 / Math.PI);

    // 如果y轴方向与预期相差很大，可能有垂直翻转
    hasVerticalFlip = Math.abs(yAxisAngle - (rotationAngle + 90)) > 45;
  }

  // 如果有反射但不需要单独标记水平/垂直翻转，可以只标记有反射
  const hasReflection = determinant < 0;
  return {
    // 变换信息
    rotationAngle: rotationAngle,
    hasReflection: hasReflection,
    hasHorizontalFlip: hasHorizontalFlip ? 1 : 0,
    hasVerticalFlip: hasVerticalFlip ? 1 : 0,

    // 详细参数
    determinant: determinant,
    scaleX: scaleX,
    scaleY: scaleY,
    hasShear: hasShear,

    // 平移信息
    translateX: matrix[0][2],
    translateY: matrix[1][2]
  };
}
export const getAngleByMatrix = (matrix) => {
  // 提取矩阵的线性变换部分
  const a = matrix[0][0];
  const b = matrix[0][1];
  const c = matrix[1][0];
  const d = matrix[1][1];

  // 计算旋转角度
  const angle = Math.atan2(c, a) * (180 / Math.PI);

  // 规范化角度到 [-180, 180] 范围
  if (angle > 180) angle -= 360;
  if (angle <= -180) angle += 360;

  return angle;
}


export const calculateCanvasSize = (gridPoints) => {
  function calculateBounds() {
    let minX = Infinity, maxX = -Infinity;
    let minY = Infinity, maxY = -Infinity;

    gridPoints.forEach(point => {
      minX = Math.min(minX, point.x);
      maxX = Math.max(maxX, point.x);
      minY = Math.min(minY, point.y);
      maxY = Math.max(maxY, point.y);
    });

    return { minX, maxX, minY, maxY };
  }

  const bounds = calculateBounds();
  const width = Math.max(Math.ceil(bounds.maxX - bounds.minX), 100);
  const height = Math.max(Math.ceil(bounds.maxY - bounds.minY), 100);

  return {
    width: width,
    height: height,
    bounds: {
      left: { value: bounds.minX },
      top: { value: bounds.minY },
      right: { value: bounds.minX + width },
      bottom: { value: bounds.maxY }
    }
  };
}

//计算矩形中心坐标
export const calculateCenterReduce = (points) => {
  const sum = points.reduce((acc, point) => {
    return [acc[0] + point[0], acc[1] + point[1]];
  }, [0, 0]);

  return [sum[0] / points.length, sum[1] / points.length];
}


//处理数组
export const handleArray = (arr) => {
  // 将一维数组按每2个元素拆成4组二维坐标
  return Array.from({ length: 4 }, (_, i) => [arr[i * 2], arr[i * 2 + 1]]);
}

export const getSmartObjectMatrix = (originalPoints, rotatedPoints) => {
  const rotatedPointsCopy = handleArray(rotatedPoints)
  let res = computePerspectiveMatrix(
    originalPoints,
    rotatedPointsCopy
  );
  return res
}


//计算矩阵
const computePerspectiveMatrix = (src, dst) => {
  const A = [];
  const b = [];
  // 每个点贡献两个方程
  for (let i = 0; i < 4; i++) {
    const [x, y] = src[i];
    const [x_, y_] = dst[i];

    // x' = a*x + b*y + tx 的方程
    A.push([x, y, 0, 0, 1, 0]);
    b.push(x_);

    // y' = c*x + d*y + ty 的方程
    A.push([0, 0, x, y, 0, 1]);
    b.push(y_);
  }
  function transpose(matrix) {
    const rows = matrix.length;
    const cols = matrix[0].length;
    const result = [];

    for (let j = 0; j < cols; j++) {
      result[j] = [];
      for (let i = 0; i < rows; i++) {
        result[j][i] = matrix[i][j];
      }
    }
    return result;
  }
  // 矩阵转置
  function transpose(matrix) {
    const rows = matrix.length;
    const cols = matrix[0].length;
    const result = [];

    for (let j = 0; j < cols; j++) {
      result[j] = [];
      for (let i = 0; i < rows; i++) {
        result[j][i] = matrix[i][j];
      }
    }
    return result;
  }
  // 矩阵乘法
  function matrixMultiply(A, B) {
    const rowsA = A.length;
    const colsA = A[0].length;
    const colsB = B[0].length;
    const result = [];

    for (let i = 0; i < rowsA; i++) {
      result[i] = [];
      for (let j = 0; j < colsB; j++) {
        let sum = 0;
        for (let k = 0; k < colsA; k++) {
          sum += A[i][k] * B[k][j];
        }
        result[i][j] = sum;
      }
    }
    return result;
  }
  // 矩阵与向量乘法
  function matrixVectorMultiply(matrix, vector) {
    return matrix.map(row => {
      return row.reduce((sum, val, j) => sum + val * vector[j], 0);
    });
  }

  // 高斯消元法解线性方程组
  function solveLinearSystem(A, b) {
    const n = A.length;
    const augmented = A.map((row, i) => [...row, b[i]]);

    // 前向消元
    for (let i = 0; i < n; i++) {
      // 寻找主元
      let maxRow = i;
      for (let j = i + 1; j < n; j++) {
        if (Math.abs(augmented[j][i]) > Math.abs(augmented[maxRow][i])) {
          maxRow = j;
        }
      }

      // 交换行
      [augmented[i], augmented[maxRow]] = [augmented[maxRow], augmented[i]];

      // 消元
      for (let j = i + 1; j < n; j++) {
        const factor = augmented[j][i] / augmented[i][i];
        for (let k = i; k <= n; k++) {
          augmented[j][k] -= factor * augmented[i][k];
        }
      }
    }

    // 回代
    const x = new Array(n);
    for (let i = n - 1; i >= 0; i--) {
      x[i] = augmented[i][n];
      for (let j = i + 1; j < n; j++) {
        x[i] -= augmented[i][j] * x[j];
      }
      x[i] /= augmented[i][i];
    }
    return x;
  }

  // 计算 A^T * A 和 A^T * b
  const AT = transpose(A);
  const ATA = matrixMultiply(AT, A);
  const ATb = matrixVectorMultiply(AT, b);
  // 解线性方程组 ATA * params = ATb
  const params = solveLinearSystem(ATA, ATb);
  // 提取参数并构建3x3矩阵
  const [a, bVal, c, d, tx, ty] = params;
  return [
    [a, bVal, tx],
    [c, d, ty],
    [0, 0, 1]
  ];
}

const matrixToCSSMatrix = (affineMatrix) => {
  const a = affineMatrix[0][0]; // h11
  const b = affineMatrix[1][0]; // h21
  const c = affineMatrix[0][1]; // h12
  const d = affineMatrix[1][1]; // h22
  const tx = affineMatrix[0][2]; // h13
  const ty = affineMatrix[1][2]; // h23
  return [
    Number(a.toFixed(9)),
    Number(b.toFixed(9)),
    0,
    Number(c.toFixed(9)),
    Number(d.toFixed(9)),
    0,
    Number(tx.toFixed(9)),
    Number(ty.toFixed(9)),
    1
  ];
  // return `matrix(${a}, ${b}, ${c}, ${d}, ${tx}, ${ty})`;
}


const calculateTransformationMatrix = (originalGridPoints, actualCornerPoints) => {
  // 原始网格的四个角点（左上、右上、右下、左下）
  const originalCorners = [
    originalGridPoints[0], // 左上
    originalGridPoints[3], // 右上
    originalGridPoints[15], // 右下
    originalGridPoints[12] // 左下
  ];
  // 使用最小二乘法计算仿射变换矩阵
  // 这里简化处理，使用透视变换近似
  const A = [];
  const b = [];

  for (let i = 0; i < 4; i++) {
    const x = originalCorners[i].x;
    const y = originalCorners[i].y;
    const xp = actualCornerPoints[i][0];
    const yp = actualCornerPoints[i][1];

    A.push([x, y, 1, 0, 0, 0, -x * xp, -y * xp]);
    A.push([0, 0, 0, x, y, 1, -x * yp, -y * yp]);
    b.push(xp, yp);
  }

  // 解线性方程组 (简化实现)
  const matrix = solveLinearSystem(A, b);

  return matrix || [1, 0, 0, 0, 1, 0, 0, 0]; // 默认单位矩阵
}

// 简化的线性方程组求解
const solveLinearSystem = (A, b) => {
  // 这里使用简化的方法，实际应用中应该使用更稳定的数值方法
  try {
    // 构造增广矩阵
    const n = A.length;
    const augmented = A.map((row, i) => [...row, b[i]]);

    // 简单的高斯消元法
    for (let i = 0; i < n; i++) {
      // 寻找主元
      let maxRow = i;
      for (let j = i + 1; j < n; j++) {
        if (Math.abs(augmented[j][i]) > Math.abs(augmented[maxRow][i])) {
          maxRow = j;
        }
      }

      // 交换行
      [augmented[i], augmented[maxRow]] = [augmented[maxRow], augmented[i]];

      // 消元
      for (let j = i + 1; j < n; j++) {
        const factor = augmented[j][i] / augmented[i][i];
        for (let k = i; k < n + 1; k++) {
          augmented[j][k] -= factor * augmented[i][k];
        }
      }
    }

    // 回代
    const x = new Array(n);
    for (let i = n - 1; i >= 0; i--) {
      x[i] = augmented[i][n] / augmented[i][i];
      for (let j = i - 1; j >= 0; j--) {
        augmented[j][n] -= augmented[j][i] * x[i];
      }
    }

    return x;
  } catch (e) {
    console.error('求解线性方程组失败:', e);
    return null;
  }
}

const transformPoint = (point, matrix) => {
  const [a, b, c, d, e, f, g, h] = matrix;
  const x = point.x;
  const y = point.y;

  const denominator = g * x + h * y + 1;
  if (Math.abs(denominator) < 1e-10) {
    return {
      x: x,
      y: y
    }; // 避免除零
  }

  return {
    x: (a * x + b * y + c) / denominator,
    y: (d * x + e * y + f) / denominator
  };
}

export const getTransformedGridPoints = (originalGridPoints, actualCornerPoints) => {
  const matrix = calculateTransformationMatrix(originalGridPoints, actualCornerPoints);
  return originalGridPoints.map(point => transformPoint(point, matrix));
}

export const combineTransforms = (m1, m2) => {
  return m2.map((row, i) =>
    row.map((_, j) =>
      m2[i][0] * m1[0][j] +
      m2[i][1] * m1[1][j] +
      m2[i][2] * m1[2][j]
    )
  );
}

export function deepClone(target) {
  if (typeof target !== "object" || target === null) {
    return target;
  }

  const cloneResult = Array.isArray(target) ? [] : {};

  for (const key in target) {
    if (Object.prototype.hasOwnProperty.call(target, key)) {
      const value = target[key];

      if (typeof value === "object" && value !== null) {
        cloneResult[key] = deepClone(value);
      } else {
        cloneResult[key] = value;
      }
    }
  }

  return cloneResult;
}


